import authSelector from 'modules/Auth/selectors'
import corporateRequest from 'utils/corporateRequest'
import studentRequest from 'utils/studentRequest'

export const getInterviweList =
  (page, sortBy) => async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)

    const sortKey = sortBy?.columnKey ? `&sortBy=${sortBy?.columnKey}` : ''
    const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
    const sortOrder = sortBy?.order ? `&orderBy=${order}` : ''

    try {
      const result = await corporateRequest.get(
        `/corporates/${corporate_id}/inteviewer/list?pageLimit=10&pageNo=${page}${sortKey}${sortOrder}`
      )
      return result?.data?.data
    } catch (error) {
      //
    }
  }

export const getInterviweListDetails =
  (page, sortBy) => async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)

    const sortKey = sortBy?.columnKey ? `&sortBy=${sortBy?.columnKey}` : ''
    const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
    const sortOrder = sortBy?.order ? `&orderBy=${order}` : ''

    try {
      const result = await corporateRequest.get(
        `/corporates/${corporate_id}/interview/inteviewer/list?pageLimit=10&pageNo=${page}${sortKey}${sortOrder}`
      )
      return result?.data?.data
    } catch (error) {
      //
    }
  }

export const getListOfRolesForInterviwer =
  ({
    userId,
    roleId,
    startDate,
    endDate,
    page,
    sortBy,
    search,
    evaluations,
    filterData,
  }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    const sortKey = sortBy?.field ? `&sort=${sortBy?.field}` : ''
    const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
    const sortOrder = sortBy?.order ? `&orderBy=${order}` : ''
    const searchBy = search ? `&search=${search}` : ''
    const occurrence = evaluations ? `&occurrence=${evaluations}` : ''
    const role = filterData?.roleId ? `&roleIds=${filterData?.roleId}` : ''
    const round = filterData?.round ? `&rounds=${filterData?.round}` : ''
    const roleData = roleId ? `&roleIds=${roleId}` : ''
    const fromDate = startDate ? `&fromDate=${startDate}` : ''
    const toDate = endDate ? `&toDate=${endDate}` : ''
    try {
      const result = await corporateRequest.get(
        `corporates/${corporate_id}/inteviewer/${userId}/interview/list?pageLimit=10&pageNo=${page}${occurrence}${role}${sortKey}${sortOrder}${searchBy}${roleData}${round}${fromDate}${toDate}`
      )
      return result?.data?.data
    } catch (error) {
      //
    }
  }

export const getListOfDatesInterviewer =
  (userId, roleIds, evaluations) => async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    const role = roleIds ? `&roleIds=${roleIds}` : ''
    const occurrence = evaluations ? `&occurrence=${evaluations}` : ''
    try {
      const result = await corporateRequest.get(
        `corporates/${corporate_id}/inteviewer/${userId}/interviewDates/list?pageLimit=1000&pageNo=0${role}${occurrence}`
      )
      return result?.data?.data
    } catch (error) {
      //
    }
  }

export const getListOfCandidateForRoleTOInterview =
  ({ userId, page, sortBy, search, filterData, roleId, startTime, stage }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)

    const sortKey = sortBy?.field ? `&sort=${sortBy?.field}` : ''
    const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
    const sortOrder = sortBy?.order ? `&orderBy=${order}` : ''
    const searchBy = search ? `&search=${search}` : ''
    const stageData = stage ? `&stage=${stage}` : ''
    const status = filterData?.status ? `&status=${filterData?.status}` : ''
    const roleData = roleId ? `&roleId=${roleId}` : ''
    const sTime = startTime ? `&startTime=${startTime}` : ''
    const fromAverageScore = filterData?.score?.minValue
      ? `&fromAverageScore=${filterData?.score?.minValue}`
      : ''
    const toAverageScore = filterData?.score?.maxValue
      ? `&toAverageScore=${filterData?.score?.maxValue}`
      : ''
    try {
      const result = await corporateRequest.get(
        `corporates/${corporate_id}/inteviewer/${userId}/candidate/list?pageLimit=10&pageNo=${page}${sTime}${sortKey}${sortOrder}${searchBy}${status}${roleData}${fromAverageScore}${toAverageScore}${stageData}`
      )
      return result?.data?.data
    } catch (error) {
      //
    }
  }

export const getFilterRoleList = userId => async (dispatch, getState) => {
  const state = getState()
  const corporate_id = authSelector.getCorporateId(state)
  try {
    const result = await corporateRequest.get(
      `corporates/${corporate_id}/inteviewer/${userId}/roles/list?pageLimit=1000&pageNo=0`
    )
    return result?.data?.data
  } catch (error) {
    //
  }
}

export const getFilterRoundList = userId => async (dispatch, getState) => {
  const state = getState()
  const corporate_id = authSelector.getCorporateId(state)
  try {
    const result = await corporateRequest.get(
      `corporates/${corporate_id}/inteviewer/${userId}/rounds/list?pageLimit=1000&pageNo=0`
    )
    return result?.data?.data
  } catch (error) {
    //
  }
}

export const getListOfCandidateListDownload =
  (userId, stage, roleId) => async (dispatch, getState) => {
    const state = getState()
    const corporate_id = authSelector.getCorporateId(state)
    try {
      const result = await studentRequest.get(
        `students/corporate/${corporate_id}/interviewer/${userId}/candidate/list/export?stage=${stage}&roleId=${roleId}`
      )
      return result
    } catch (error) {
      return error
    }
  }

export const bulkFileUploadStatus =
  ({ interviewId, interviewerID, payload }) =>
  async () => {
    try {
      const result = await corporateRequest.put(
        `corporates/interview/${interviewId}/${interviewerID}/students/bulkScoreUpdate`,
        payload
      )
      return result
    } catch (error) {
      return error
    }
  }

export const getDriveScoreDetails = (driveId, studentId) => async () => {
  try {
    const result = await corporateRequest.get(
      `corporates/drive/${driveId}/student/${studentId}/scoreDetails`
    )
    return result?.data?.data
  } catch (error) {
    //
  }
}
export const getDriveScoreParameterDetails =
  (studentInterviewmap, interviewerId) => async () => {
    try {
      const result = await corporateRequest.get(
        `corporates/interview/${studentInterviewmap}/interviewer/${interviewerId}/scoreDetails`
      )
      return result?.data?.data
    } catch (error) {
      //
    }
  }

export const getRoleRoundInterviewerLists =
  (roleId, round, startTime) => async () => {
    try {
      const result = await corporateRequest.get(
        `corporates/role/${roleId}/interviewRound/startTime/${startTime}?interviewRound=${round}`
      )
      return result?.data?.data
    } catch (error) {
      //
    }
  }
